import { LineItem } from '@lib/cart'

import {
  configurationIdAttributeKey,
  productVariantIdAttributeKey,
} from '@lib/shopify/cart'

import CartItem from '@blocks/shop/cart-item'

interface CartItemsProps {
  items: LineItem[]
  itemClassName?: string
}

const CartItems = ({ items, itemClassName }: CartItemsProps) => {
  const feeItems = items.filter((item) => item.product?.type === 'fee')
  const nonFeeItems = items.filter((item) => item.product?.type !== 'fee')

  return (
    <div>
      {nonFeeItems.map((item, index) => {
        const itemConfigurationIdAttribute = item.attributes?.find(
          (attribute) => attribute.key === `_${configurationIdAttributeKey}`,
        )
        const itemConfigurationId = itemConfigurationIdAttribute?.value
        const itemFeeItems = feeItems.filter((feeItem) => {
          if (!feeItem.attributes) {
            return false
          }

          // Validate that line item an fee item configuration IDs match
          const feeItemConfigurationIdAttribute = feeItem.attributes?.find(
            (attribute) => attribute.key === `_${configurationIdAttributeKey}`,
          )
          const feeItemConfigurationId = feeItemConfigurationIdAttribute?.value

          if (itemConfigurationId !== feeItemConfigurationId) {
            // TODO: Validation disabled.
            // return false
          }

          return feeItem.attributes.some((attribute) => {
            return (
              attribute.key === `_${productVariantIdAttributeKey}` &&
              attribute.value === item.id.toString()
            )
          })
        })

        return (
          <CartItem
            key={`${index}-${item.id}`}
            item={item}
            feeItems={itemFeeItems}
            className={itemClassName}
          />
        )
      })}
    </div>
  )
}

export default CartItems
